import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const PrivacyThirdParty = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{      
      margin: 0,
      marginLeft: {xs: '-17px', sm: '-15px', md: '-15px'},
      mt: '-20px',
      pt: 0,
      flexDirection: 'column',
      background: '#FFF'
    }}>
      
      {/* Terms Content */}
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '15px',  }}>
          {t('privacy_third_party_title')}
        </Typography>
        <Typography sx={{ 
          mt: 2,
          
          fontSize: '14px', 
          color: '#333', 
          lineHeight: 1.7, 
          whiteSpace: 'pre-wrap',
          textAlign: 'left'
        }}
        dangerouslySetInnerHTML={{ __html: t('privacy_third_party_content') }}
        />
      </Box>
    </Box>
  );
}; 